import React from 'react';
import { connect } from 'react-redux';
import styles from './RequestHelp.module.css'

class HelpCenterRequestHelp extends React.Component {

    render() {
        let row = 0;
        return (
            <div>
                <div className={styles.header}>Contacts</div>
                <div className={styles.wrapper}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        {Object.keys(this.props.contacts)
                            .map(id => {
                                const contact = this.props.contacts[id];
                                row++;
                                return (
                                    <div className={row % 2 === 0 ? styles.contact_wrapper : styles.contact_wrapper_odd} key={contact.HCNO}>
                                        <span className={styles.contact_name}>{contact.HCNAME}</span>
                                        <span className={styles.contact_number}>{contact.HCNUMBER}</span>
                                    </div>
                                );
                            })
                        }
                    </span>
                    <span className={styles.col3} />
                    <span className={styles.col4} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let contacts = state.entities.masterData.PTMASTERHELPCONTACTS ? Object.keys(state.entities.masterData.PTMASTERHELPCONTACTS)
        .filter(x => state.entities.masterData.PTMASTERHELPCONTACTS[x].HCENABLED === true)
        .sort((a, b) => state.entities.masterData.PTMASTERHELPCONTACTS[a].HCORDER - state.entities.masterData.PTMASTERHELPCONTACTS[b].HCORDER)
        .map(x => state.entities.masterData.PTMASTERHELPCONTACTS[x]) : {};

    return {
        contacts
    };
}

const connectedHelpCenterRequestHelp = connect(mapStateToProps)(HelpCenterRequestHelp);
export { connectedHelpCenterRequestHelp as HelpCenterRequestHelp }
